<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerar CTE Complementar</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                        api-url="/api/ctecomplementar"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="doctransp_id"
                                        pagination-path=""
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:cell-clicked="onDetail"
                                        @vuetable:loaded="onLoaded"
                                        detail-row-component="ctecomplementar-detalhes"
                                      >
                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onCreate(props.rowData)" v-b-tooltip title="Gerar CTE"><i v-if="props.rowData.b_modal.cd==1" class="fa fa-truck"></i>
                                                                                                              <i v-if="props.rowData.b_modal.cd==2" class="fa fa-plane"></i>
                                                                                                              <i v-if="props.rowData.b_modal.cd==3" class="fa fa-ship"></i>
                                                                                                              <i v-if="props.rowData.b_modal.cd==4" class="fa fa-train"></i>
                                                                                                              <i v-if="props.rowData.b_modal.cd==5" class="fa fa-tint"></i>
                                                                                                              <i v-if="props.rowData.b_modal.cd==6" class="fa fa-tasks"></i></a>
                                           <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                          </button>
                                        </div>
                                      </template>
                                  </vuetable>
                              </div>
                            <div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     size="lg"
                      v-model="showModal"
                     :ok-disabled=form.errors.any()
                     @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">

                  <b-container fluid class="p-a-0">
                      <b-row>
                          <b-col>
                          <label>CST</label>
                          <b-form-input type="text"
                                        placeholder="CST"
                                        v-model="form.cst"
                                        name="cst"
                                        >
                          </b-form-input>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('cst')" v-if="form.errors.has('cst')"></b-form-feedback>
                      </b-col>
                          <b-col>
                            <label>Valor Líquido</label>
                            <input v-model.lazy="form.vlr_cte"
                                 v-money="vlr"
                                 v-on:keyup="calcCte"
                                 name="vlr_cte"
                                 type="text"
                                 class="form-control"
                                 style="text-align: right" />
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                          </b-col>
                        <b-col>
                            <label>Alíquota</label>
                            <input v-model.lazy="form.vlr_aliquota"
                                   v-money="aliquota"
                                   v-on:keyup="calcCte"
                                   name="vlr_aliquota"
                                   type="text"
                                   class="form-control"
                                   style="text-align: right" />
                              <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>% Redução BC</label>
                              <input v-model.lazy="form.percentual_reducao_bc"
                                     v-money="percentual_reducao_bc"
                                     name="percentual_reducao_bc"
                                     type="text"
                                     class="form-control"
                                     style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_reducao_bc')" v-if="form.errors.has('percentual_reducao_bc')"></b-form-feedback>
                            </b-col>

                          <b-col>

                          <label>Imposto</label>
                          <input v-model.lazy="form.vlr_imposto"
                                 v-money="vlr"
                                 name="vlr_imposto"
                                 type="text"
                                 class="form-control"
                                 style="text-align: right" />
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                        </b-col>
                        <b-col>

                        <label>Valor Total do CTE</label>
                        <input v-model.lazy="form.vlr_total"
                               v-money="vlr"
                               name="vlr_total"
                               type="text"
                               class="form-control"
                               readonly="true"
                               style="text-align: right" />
                          <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                      </b-col>
                    </b-row>
                    </b-container>

                    <b-container fluid class="p-a-0">
                        <b-row>
                            <b-col>
                                <label>CFOP</label>
                                <multiselect v-model="form.cfop"
                                :options="optionsLivCfop"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('cfop')" v-if="form.errors.has('cfop')"></b-form-feedback>
                            </b-col>
                            <b-col>
                                <label>Tipo Custo</label>
                                <multiselect v-model="form.custo"
                                :options="optionsCusto"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('custo')" v-if="form.errors.has('custo')"></b-form-feedback>
                            </b-col>
                        </b-row>
                    </b-container>
                    <label>Observação</label>

                    <b-form-textarea id="textarea1"
                                     name="obs"
                                     v-model="form.obs"
                                     placeholder="Observação"
                                     :rows="4"
                                     :max-rows="6">
                    </b-form-textarea>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>

                    <label>Observação Fiscal</label>

                    <b-form-textarea id="textarea2"
                                     name="obs_fiscal"
                                     v-model="form.obs_fiscal"
                                     placeholder="Observação Fiscal"
                                     :rows="4"
                                     :max-rows="6">
                    </b-form-textarea>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fiscal')" v-if="form.errors.has('obs_fiscal')"></b-form-feedback>

                </form>

                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModal=false" variant="secondary">
                             Cancelar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                             Gerar CTE
                           </b-btn>
                       </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import CteComplementarFilterBar from './CteComplementarFilterBar'
import accounting from 'accounting'
import moment from 'moment'
import {VMoney} from 'v-money'
import CteComplementarDetalhes from './CteComplementarDetalhes'

Vue.component('ctecomplementar-detalhes', CteComplementarDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': CteComplementarFilterBar,
        VMoney,
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          vn_vlr_cte: 0,
          vn_aliquota: 0,
          vn_percentual_reducao_bc: 0,
          activateDesativate: [],
          optionsCusto: [],
          optionsLivCfop: [],
          helpForm: new Form({statusRecord: [], params: []}),
          vlr: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          aliquota: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          percentual_reducao_bc: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          form: new Form({
                    cst: '',
                    vlr_cte: 0,
                    vlr_aliquota: 0,
                    vlr_imposto: 0,
                    vlr_total: 0,
                    percentual_reducao_bc: 0,
                    doctransp_id: '',
                    custo: [],
                    obs: '',
                    cfop: '',
                    obs_fiscal: ''
                }),
          fields: [
            {
              name: 'doc_transp_partes_env.emi_cnpj',
              title: 'Emitente'
            },
            {
              name: 'doc_transp_partes_env.emi_nome',
              title: 'Razão'
            },
            {
              name: 'num_doc',
              title: 'Nº Doc'
            },
            {
              name: 'serie',
              title: 'Série'
            },
            {
              name: 'dt_emissao',
              title: 'Data',
              callback: 'formatDate|DD/MM/YYYY'

            },
            {
              name: 'b_modal.descr',
              title: 'Modal'
            },
            {
              name: 'doc_transp_vlr_prestacao.vlr_total_prestacao',
              title: 'Valor',
              callback: 'formatNumber'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getCusto();
        this.getLivCfop();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.moreParams = {
                'num_doc': data_filter.num_doc,
                'modal': data_filter.modal.value
            }
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterReset () {
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.doctransp_id);
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatDate (value, fmt = 'D MM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY/MM/DD').format(fmt)
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.parareemp_id);
            }
        },
        onCreate (data) {
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.isDisabled = false;
            this.form.reset();
            this.form.doctransp_id = data.doctransp_id;
            this.form.cst          = data.doc_transp_imposto.cst;
            this.form.cfop = {label: data.cfop, value: data.cfop};
            this.form.obs          = data.doc_transp_adicional.obs_geral;
            this.form.obs_fiscal   = data.doc_transp_adicional.inf_adicional_fisco;
            this.form.vlr_aliquota = data.doc_transp_imposto.aliquota_icms*100; // Formato vem apenas 12, transformando em 0,12
            this.form.percentual_reducao_bc = 0; // Formato vem apenas 12, transformando em 0,12
            this.form.vlr_total    = 0;
            this.$refs.modal_form.show();
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/ctecomplementar/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte.replace( ".", "" );
            this.vn_vlr_cte = this.vn_vlr_cte.replace( ",", "." );
            this.vn_vlr_cte = parseFloat( this.vn_vlr_cte.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte).toFixed(2);

            this.vn_vlr_total = parseFloat(this.vn_vlr_cte)+parseFloat(this.form.vlr_imposto);
            this.form.vlr_total = Number(this.vn_vlr_total).toFixed(2);
            // this.form.vlr_imposto = this.vn_vlr_cte*(this.vn_aliquota).toFixed(2);
        },
        getCusto() {
            this.loading = true;
            this.isDisabled = true;
            this.form.get('/api/custo/jsonlistExtra').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsCusto.push({ label: obj.descr, value: obj.custo_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getLivCfop() {
            this.helpForm.params = { tabela: 'doc_cte',
                                    coluna: 'cfop' };

            this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsLivCfop.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        getPermission(checkPermission) {
            //return true;
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
